import { render } from "./login.vue?vue&type=template&id=33d59959&scoped=true"
import script from "./login.vue?vue&type=script&lang=js"
export * from "./login.vue?vue&type=script&lang=js"

import "./login.vue?vue&type=style&index=0&id=33d59959&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-33d59959"

export default script